import {
  React,
  Component,
  withRouter,
  RichTextEditor,
  helpers,
  axios,
  pdfGenerator,
} from 'imports/CommonImports';

import {
  Dialog,
  FlatButton,
  CircularProgress,
} from 'material-ui';

//TODO: Sacar hardcodeo
const API_KEY = "AIzaSyDpWo5PvDlwr1qCxIaj3pVVbsOnQDxCxg0";

const styles = {
  contentContainer: {
    overflow: 'scroll'
  },
  section: {
    width: '100%',
    borderTop: '1px solid #7e7e7e',
    paddingTop: '1em',
  },
  sectionHeader: {
    color: '#FFFFFF',
    fontWeight: 'bold',
    fontSize: '1em',
    backgroundColor: '#1b2543',
    padding: '3px 0',
    width: '30%',
    textAlign: 'center',
    marginBottom: '1em',
  },
  label: {
    fontWeight: 'bold',
    marginRight: '1em',
  },
  parragraph: {
    marginTop: '0.3em',
  },
  subsubHeader: {
    fontSize: '14px',
    marginBottom: '5px'
  },
  datesContainer: {
    display: 'flex',
    justifyContent: 'space-around'
  },
  rowContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '0px'
  },
  columnContainer: {
    display: 'flex',
    flexDirection: 'column',
    margin: '0.5em 2em',
  },
  loaderContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px'
  },
  table: {
    width: '100%',
    border: '1px solid black',
    borderCollapse: 'collapse',
  },
  tableComponent: {
    border: '1px solid black',
    borderCollapse: 'collapse',
    color: '#1b2543',
  }
}

class ProjectPreview extends Component {

  constructor(props){
    super(props);
    this.state = {
      open: true,
      methodValue: RichTextEditor.createValueFromString(props.project.method.text, 'html'),
      loading: true,
      today: new Date(Date.now()),
    }
  }

  componentDidMount() {
    //Get Data from rows
    axios.get('https://sheets.googleapis.com/v4/spreadsheets/' + this.props.project.calculation.excel_link + '/values/A1:M500?key=' + API_KEY)
    .then(res => {
      this.setState({
        loading: false,
        excelValues: res.data.values || [],
      })
    })
    .catch(err => {
      console.log(err);
    });
  }

  render() {
    const actions = [
       <FlatButton
         label="Descargar"
         primary={true}
         onClick={this.download}
       />,
       <FlatButton
         label="Cerrar"
         primary={true}
         onClick={this.props.handleClose}
       />,
        ];
    let project = this.props.project
    return (
      <Dialog
        ref={el => this.print = el}
        open={this.state.open}
        actions={actions}
        onRequestClose={this.props.handleClose}
        children={this.getChildren(project)}
        autoScrollBodyContent={true}
        >

      </Dialog>
    );
  }

  getChildren = (project) => {
    console.log(project);
    if(this.state.loading)
      return (
      <div style={styles.loaderContainer} id='full'>
        <CircularProgress color='#9e9e9e' size={80} thickness={5} />
      </div>
    );
    else{
      return(
        <div style={styles.contentContainer} id='full'>
          <div>
            <p style={{marginBottom: '0'}}>Ficha Proyecto i3</p>
            <h2 style={{margin: '3px 0', fontWeight: 'bold'}}>{project.information.name}</h2>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
              <p style={{marginTop: '0'}}>{this.props.companyName}</p>
              <p style={{marginTop: '0'}}>{this.state.today.getDay()} de {helpers.dateFormatter(this.state.today)}</p>
            </div>
          </div>
          <div style={styles.section}>
            <div style={styles.sectionHeader}> Información General </div>
            <div style={styles.rowContainer}>
              <div style={styles.columnContainer}>
                <div style={styles.rowContainer}>
                  <p style={styles.label}>Nombre de Proyecto:</p>
                  <p style={styles.subHeader}>{project.information.name}</p>
                </div>
                <div style={styles.rowContainer}>
                  <p style={styles.label}>Líder de Proyecto:</p>
                  <p style={styles.subHeader}>{project.information.leader_first_name + ' ' + project.information.leader_last_name}</p>
                </div>
                <div style={styles.rowContainer}>
                  <p style={styles.label}>Sponsor de Proyecto:</p>
                  <p style={styles.subHeader}>{project.information.sponsor_first_name + ' ' + project.information.sponsor_last_name}</p>
                </div>
              </div>
              <div style={styles.columnContainer}>
                <div style={styles.rowContainer}>
                  <p style={styles.label}>Área:</p>
                  <p style={styles.subHeader}>{project.information.area.name}</p>
                </div>
                <div style={styles.rowContainer}>
                  <p style={styles.label}>Año de lanzamiento:</p>
                  <p style={styles.subHeader}>{new Date(project.information.start_date).getFullYear()}</p>
                </div>
                <div style={styles.rowContainer}>
                  <p style={styles.label}>Año de término medición:</p>
                  <p style={styles.subHeader}>{new Date(project.information.end_date).getFullYear()}</p>
                </div>
              </div>
            </div>
            <div style={styles.columnContainer}>
              <p style={styles.label}>Descripción:</p>
              <p style={styles.parragraph}>{project.information.description}</p>
              <p style={styles.label}>Principales Beneficios:</p>
              <p style={styles.parragraph}>{project.information.benefits}</p>
              <p style={styles.label}>Actividades realizadas:</p>
              <p style={styles.parragraph}>{project.information.activities_done}</p>
            </div>
          </div>

          <div >
          <div style={styles.section}>
            <div style={styles.sectionHeader}> Método de cálculo </div>
            <p dangerouslySetInnerHTML={this.getHtmlProjectMethod(this.state.methodValue.toString('html'))}></p>
            </div>
          </div>

          <div >
          <div style={styles.section}>
            <div style={styles.sectionHeader}> Resumen del cálculo </div>
            {this.generateTable(this.state.excelValues)}
            </div>
          </div>
        </div>
      );
    }
  }

  generateTable = (excelDataArray) => {
    var table = (
      <table style={styles.table}>
      <tbody>
      {excelDataArray.map((row, i) => {
        let width_style = {width: 100/excelDataArray.length+'%'};
        return (
          <tr key={i} style={styles.tableComponent}>
          { row.map((column, j) => {
            return (<th key={"(" + i + "," + j + ")"} style={{...styles.tableComponent,...width_style}}> {column} </th>);
          })}
          </tr>
        );
      })}
      </tbody>
      </table>
    );
    return table;
  }

  getHtmlProjectMethod = (methodText) => {
    return {__html: methodText}
  }

  download = () => {
    pdfGenerator(document.getElementById('full'), this.props.project.information.name)
  }
}

export default withRouter(ProjectPreview);



// WEBPACK FOOTER //
// ./src/components/files/ProjectPreview.js